import {
  LAYOUT_COMPONENT_TYPE,
  REGISTRY_BLOCK,
  type LayoutBlock,
  type RegistryBlockPresentation,
} from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

const FRAMES = [
  'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1559339352-11d035aa65de?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1556910103-1c02745aae4d?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1466978913421-dad2ebd01d17?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1552566626-52f8b828add9?auto=format&fit=crop&w=1400&q=80',
] as const;

const CAPTIONS = [
  ['Gastraum am Abend', 'Dining room at dusk'],
  ['Die Theke', 'The counter'],
  ['Platz am Fenster', 'A seat by the window'],
  ['Durchreiche zur Küche', 'The kitchen pass'],
  ['Eingang von der Straße', 'Street entrance'],
  ['Licht über dem Tisch', 'Light over the table'],
] as const;

function galleryBlock(
  blockId: string,
  registryBlockKey: RegistryBlockPresentation,
): LayoutBlock {
  const content: LayoutBlock['content'] = {
    sectionTitle: loc3('Das Haus', 'The house'),
    sectionSubtitle: loc3(
      'Ein kurzer Rundgang: Gastraum, Theke und das Licht über dem Tisch.',
      'A short walk through: dining room, counter, and the light over the table.',
    ),
  };
  const media: LayoutBlock['media'] = {};
  CAPTIONS.forEach((copy, index) => {
    const slot = index + 1;
    content[`caption${slot}`] = loc3(copy[0], copy[1]);
    media[`frame${slot}`] = FRAMES[index]!;
  });

  return {
    blockId,
    componentType: LAYOUT_COMPONENT_TYPE.imageGallery,
    registryBlockKey,
    displayOrder: 4,
    content,
    media,
  };
}

export const imageGalleryMosaicDefault = galleryBlock(
  FIXTURE_BLOCK_IDS.imageGalleryMosaic,
  REGISTRY_BLOCK.presentation.imageGalleryMosaic,
);

export const imageGalleryMasonryDefault = galleryBlock(
  FIXTURE_BLOCK_IDS.imageGalleryMasonry,
  REGISTRY_BLOCK.presentation.imageGalleryMasonry,
);

export const imageGalleryFilmstripDefault = galleryBlock(
  FIXTURE_BLOCK_IDS.imageGalleryFilmstrip,
  REGISTRY_BLOCK.presentation.imageGalleryFilmstrip,
);

export const imageGallerySpotlightDefault = galleryBlock(
  FIXTURE_BLOCK_IDS.imageGallerySpotlight,
  REGISTRY_BLOCK.presentation.imageGallerySpotlight,
);

export const imageGalleryLedgerDefault = galleryBlock(
  FIXTURE_BLOCK_IDS.imageGalleryLedger,
  REGISTRY_BLOCK.presentation.imageGalleryLedger,
);
